import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MapFeatureLink } from '../../../models/map-feature-link';
import { linkCaptureImage } from '../../../helpers/design-context';

@Component({
    selector: 'app-location-section',
    templateUrl: './location-section.component.html',
    styleUrls: ['./location-section.component.scss'],
    standalone: false
})
export class LocationSectionComponent {
  @Input() latitude: any;
  @Input() longitude: any;
  @Input() locationText: any;
  @Input() stationRange: any;
  @Input() isEditable: boolean = true;
  @Input() hideLabel: boolean = false;
  /** A linked record's design-context link: its capture, when it has one, takes the minimap's place (spec addendum §11). */
  @Input() mapFeatureLink: MapFeatureLink | null = null;
  @Output() onDelete: EventEmitter<any> = new EventEmitter();

  get hasCapture(): boolean { return !!linkCaptureImage(this.mapFeatureLink); }

  hasGpsLocation() {
    return this.latitude !== null && this.latitude !== undefined && this.latitude !== '' &&
      this.longitude !== null && this.longitude !== undefined && this.longitude !== '';
  }

  hasStationRange() {
    return !!(
      this.stationRange?.from?.station ||
      this.stationRange?.from?.offset_type ||
      this.stationRange?.from?.offsetType ||
      this.stationRange?.from?.offset_distance ||
      this.stationRange?.from?.offsetDistance ||
      this.stationRange?.to?.station ||
      this.stationRange?.to?.offset_type ||
      this.stationRange?.to?.offsetType ||
      this.stationRange?.to?.offset_distance ||
      this.stationRange?.to?.offsetDistance ||
      this.stationRange?.alignment
    );
  }

  getOffsetType(point: any) {
    return point?.offset_type || point?.offsetType;
  }

  getOffsetDistance(point: any) {
    return point?.offset_distance || point?.offsetDistance;
  }

  deleteLocation(event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this.onDelete.emit(event);
  }
}
